module.exports = __webpack_public_path__ + "img/btn_google_dark_normal_ios.1bb80544.svg";